import { createSlice } from '@reduxjs/toolkit';
import { storeInSessionStorage } from 'utils/functions/session-storage';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    message: null,
    type: null,
    color: null
  },
  reducers: {
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
      storeInSessionStorage('notifications', state.notifications);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter((notification) => notification.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    showNotification: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type || 'info';
      state.color = action.payload.color || ''; // Default color is white
    },
    hideNotification: (state) => {
      state.message = null;
      state.type = null;
      state.color = null;
    }
  }
});

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
